import DevLog from '../../devlog/Module'
import ViewportModule from '../../viewport/Module'
import PreviewModule from '../../preview/Module'
import errorAction from '../../../actions/error/errorAction'
import transferActionProps from '../transferActionProps'
import { doPost } from '../doPost'

import { IAction, SurveyMode } from '../../../actions/types'
import { ModuleID } from '../../types'
import { IErrorResponse, IRequestSetLocaleBody } from '../types'

import { DEBUG_CLIENT } from '../const'
import { getURLfromAction } from '../lib'
import ClientModule from '@aytm/app/swidget/base/modules/client/Module.ts'

export default async function requestSetLocale(fromAction: IAction, mode: SurveyMode, target: string) {
  const body: IRequestSetLocaleBody = {
    device: ViewportModule.viewport.device,
    mode: mode,
    proxy_params: {},
    payload: target ? { name: 'set_locale', target } : {}
  }

  if (DEBUG_CLIENT) {
    DevLog._log(`SW[${ModuleID.CLIENT}]:`, 'requestSetLocale', body)
  }

  let nextAction = errorAction({ ...fromAction, mode })
  try {
    const response = await doPost<IAction | IErrorResponse>(
      PreviewModule.resetURL ? getURLfromAction(fromAction, PreviewModule.resetURL) : getURLfromAction(fromAction),
      body
    ).catch(error => {
      DevLog.error(`SW[${ModuleID.CLIENT}]:`, 'requestSetLocale', String(error), error)
      return errorAction({ ...fromAction, mode })
    })
    ClientModule.locale = target
    nextAction =
      'error' === (response as IErrorResponse).status ? errorAction({ ...fromAction, mode }) : (response as IAction)
  } catch (error) {
    DevLog.error(`SW[${ModuleID.CLIENT}]:`, 'requestSetLocale', String(error as string), error)
  }

  return transferActionProps(fromAction, nextAction)
}
